import { cn } from '@/lib/utils';
import { splitAccentCopy } from './ticketMotion';

/** Accent *words* in orange; remaining copy stays white. */
export function ClaimPrizeBar({
  copy,
  className,
  variant = 'pill',
}: {
  copy: string;
  className?: string;
  variant?: 'pill' | 'card';
}) {
  return (
    <div
      data-name="RAFFLE_CLAIM_BAR"
      className={cn(
        'mx-auto text-center font-screen-body text-white backdrop-blur-md',
        variant === 'pill' &&
          'max-w-3xl rounded-full border border-white/15 bg-white/[0.08] px-6 py-3 text-base',
        variant === 'card' &&
          'w-full max-w-[320px] rounded-[14px] border border-white/20 bg-white/[0.08] px-[18px] py-4 text-[15px] font-semibold leading-[1.45]',
        className,
      )}
    >
      {splitAccentCopy(copy).map((part, index) =>
        part.accent ? (
          <span key={index} className="font-semibold text-[#FF6B3D]">
            {part.text}
          </span>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </div>
  );
}
